export default __webpack_public_path__ + "static/media/gustave.c9151efd.png";